import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, resolveDirective as _resolveDirective, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7491270b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "Schedule_Visit_Hos_Pal_Patient"
}
const _hoisted_2 = {
  key: 0,
  class: "p-5 d-flex flex-column text-center text-primary"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin font-size-5xl me-2 animated slow flash infinite" }, null, -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-1 big-text" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Loading...")
], -1 /* HOISTED */))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "task-details"
}
const _hoisted_7 = { class: "container row m-0 p-1" }
const _hoisted_8 = { class: "col-12 mt-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "me-2" }, "Patient:", -1 /* HOISTED */))
const _hoisted_10 = { class: "mt-2 mb-1" }
const _hoisted_11 = { class: "me-2" }
const _hoisted_12 = { class: "mt-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "me-2" }, "Agency:", -1 /* HOISTED */))
const _hoisted_14 = { class: "col-12" }
const _hoisted_15 = {
  key: 0,
  class: "form-group form-check custom-checkbox mt-2"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "view-visit-orders"
}, " View Visit Orders ", -1 /* HOISTED */))
const _hoisted_17 = {
  key: 0,
  class: "form-group col-12"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Visit Orders", -1 /* HOISTED */))
const _hoisted_20 = {
  key: 0,
  class: "w-50"
}
const _hoisted_21 = { class: "table table-responsive-md border border-gray" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "bg-table-header" }, [
  /*#__PURE__*/_createElementVNode("th", null, "Discipline"),
  /*#__PURE__*/_createElementVNode("th", null, "Frequency"),
  /*#__PURE__*/_createElementVNode("th", null, "Effective Date")
], -1 /* HOISTED */))
const _hoisted_23 = { class: "white-space-pre" }
const _hoisted_24 = { class: "white-space-pre" }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "form-group col-12 col-md-6 mt-2" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "repeat" }, " Repeat ", -1 /* HOISTED */))
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "form-group col-12 col-md-6 mt-2" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "date-to" }, " Date ", -1 /* HOISTED */))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */))
const _hoisted_32 = {
  key: 0,
  class: "fw-normal ms-1"
}
const _hoisted_33 = { key: 0 }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "(Current Benefit Period: ", -1 /* HOISTED */))
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mx-1" }, "-", -1 /* HOISTED */))
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { class: "input-group date datepickerInput" }
const _hoisted_42 = ["value"]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */))
const _hoisted_44 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_45 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_46 = {
  key: 4,
  class: "field-invalid"
}
const _hoisted_47 = { class: "form-group col-12 col-md-6 mt-2" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "task" }, " Task ", -1 /* HOISTED */))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */))
const _hoisted_50 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_51 = { class: "form-group col-12 col-md-6 mt-2" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "employee" }, " Employee ", -1 /* HOISTED */))
const _hoisted_53 = { class: "form-group col-6 col-md-4 mt-2" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "payer" }, " Payer ", -1 /* HOISTED */))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Payer", -1 /* HOISTED */))
const _hoisted_57 = ["label"]
const _hoisted_58 = ["value"]
const _hoisted_59 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_60 = {
  key: 1,
  class: "form-group col-6 col-md-4 mt-2"
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "shift-length" }, " Shift Length ", -1 /* HOISTED */))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Select Shift Length", -1 /* HOISTED */))
const _hoisted_63 = ["value"]
const _hoisted_64 = {
  key: 2,
  class: "form-group col-6 col-md-4 mt-2"
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "shift-time" }, " Shift Start Time ", -1 /* HOISTED */))
const _hoisted_66 = ["value", "disabled"]
const _hoisted_67 = {
  key: 3,
  class: "form-group col-6 col-md-4 mt-2"
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "shift-time" }, " Scheduled Start Time ", -1 /* HOISTED */))
const _hoisted_69 = ["value"]
const _hoisted_70 = {
  key: 4,
  class: "form-group col-6 col-md-4 mt-2"
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "shift-end-time" }, " Scheduled End Time ", -1 /* HOISTED */))
const _hoisted_72 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_73 = ["value", "disabled"]
const _hoisted_74 = {
  key: 1,
  class: "field-invalid"
}
const _hoisted_75 = {
  key: 5,
  class: "form-group form-check custom-checkbox col-4 col-md-2 mt-2 ms-3"
}
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "on-call-visit"
}, " On-Call Visit ", -1 /* HOISTED */))
const _hoisted_77 = {
  key: 6,
  class: "col-6 col-md-4 mt-2 ms-md-3 row"
}
const _hoisted_78 = { class: "form-group form-check custom-radio col-12 col-md-6" }
const _hoisted_79 = ["value"]
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "on-call"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "On-Call Visit")
], -1 /* HOISTED */))
const _hoisted_81 = { class: "form-group form-check custom-radio col-12 col-md-6" }
const _hoisted_82 = ["value"]
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "prn"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "PRN Visit")
], -1 /* HOISTED */))
const _hoisted_84 = {
  key: 0,
  class: "col-12 col-lg-10 offset-md-1 row g-0 mb-2"
}
const _hoisted_85 = { class: "col-12 col-lg-11 bg-white text-center selected-dates-wrap" }
const _hoisted_86 = /*#__PURE__*/_createTextVNode(" task will be assigned to ")
const _hoisted_87 = /*#__PURE__*/_createTextVNode(" on the following dates:")
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_89 = {
  key: 0,
  class: "me-1"
}
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_91 = { key: 0 }
const _hoisted_92 = /*#__PURE__*/_createTextVNode(" From ")
const _hoisted_93 = /*#__PURE__*/_createTextVNode(" to ")
const _hoisted_94 = { class: "col-12 col-lg-10 offset-md-1 row g-0 justify-content-center" }
const _hoisted_95 = {
  key: 0,
  class: "col-12 col-lg-10 col-md-5 pe-2 ms-2"
}
const _hoisted_96 = {
  key: 2,
  class: "d-flex flex-wrap-reverse flex-md-nowrap justify-content-center my-2"
}
const _hoisted_97 = {
  key: 1,
  class: "p-3"
}
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-center text-warning fw-bold" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-triangle" }),
  /*#__PURE__*/_createElementVNode("span", null, " Warning: The task you are attempting to schedule is outside of the ordered visit frequency. ")
], -1 /* HOISTED */))
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-center text-warning fw-bold" }, "Do you want to continue scheduling?", -1 /* HOISTED */))
const _hoisted_100 = { class: "text-center" }
const _hoisted_101 = { key: 2 }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "p-5 d-flex flex-column text-center text-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-save fa-7x me-2 animated slow flash infinite" }),
  /*#__PURE__*/_createElementVNode("strong", { class: "mt-1" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Save Task In Progress...")
  ])
], -1 /* HOISTED */))
const _hoisted_103 = [
  _hoisted_102
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormatName = _resolveComponent("FormatName")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_DateRangePicker = _resolveComponent("DateRangePicker")!
  const _component_MultiDatePicker = _resolveComponent("MultiDatePicker")!
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_TimePicker = _resolveComponent("TimePicker")!
  const _component_FrequencyCheck = _resolveComponent("FrequencyCheck")!
  const _component_SaveNotifyUser = _resolveComponent("SaveNotifyUser")!
  const _component_FormSection = _resolveComponent("FormSection")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isFrequencyWarningRequested && !_ctx.isScheduling)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createVNode(_component_FormSection, {
            "full-height": false,
            title: "Employee Scheduler",
            "application-id": _ctx.visitDetails.Application,
            "show-product-pill": true
          }, {
            content: _withCtx(() => [
              (_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("section", _hoisted_2, _hoisted_5))
                : (_openBlock(), _createElementBlock("section", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _hoisted_9,
                        _createVNode(_component_FormatName, {
                          "first-name": _ctx.visitDetails.FirstName,
                          "last-name": _ctx.visitDetails.LastName
                        }, null, 8 /* PROPS */, ["first-name", "last-name"]),
                        _createElementVNode("p", _hoisted_10, [
                          _createElementVNode("strong", _hoisted_11, _toDisplayString(_ctx.carePeriodTitle), 1 /* TEXT */),
                          _createElementVNode("span", null, _toDisplayString(_ctx.carePeriod), 1 /* TEXT */)
                        ]),
                        _createElementVNode("p", _hoisted_12, [
                          _hoisted_13,
                          _createElementVNode("span", null, _toDisplayString(_ctx.visitDetails.AgencyName), 1 /* TEXT */)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        (!_ctx.isPalliativeSolution)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                id: "view-visit-orders",
                                class: "form-check-input",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.viewVisitOrders) = $event))
                              }, null, 512 /* NEED_PATCH */), [
                                [_vModelCheckbox, _ctx.viewVisitOrders]
                              ]),
                              _hoisted_16
                            ]))
                          : _createCommentVNode("v-if", true)
                      ]),
                      (_ctx.viewVisitOrders)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _hoisted_18,
                            _hoisted_19,
                            (_ctx.visitOrders.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                  _createElementVNode("table", _hoisted_21, [
                                    _createElementVNode("tbody", null, [
                                      _hoisted_22,
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visitOrders, (order, index) => {
                                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                          _createElementVNode("td", null, _toDisplayString(order.discipline), 1 /* TEXT */),
                                          _createElementVNode("td", _hoisted_23, _toDisplayString(order.frequency), 1 /* TEXT */),
                                          _createElementVNode("td", _hoisted_24, _toDisplayString(order.effectiveDate), 1 /* TEXT */)
                                        ]))
                                      }), 128 /* KEYED_FRAGMENT */))
                                    ])
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("p", _hoisted_25, "There are no current orders for visits."))
                          ]))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("div", _hoisted_26, [
                        _hoisted_27,
                        _withDirectives(_createElementVNode("select", {
                          id: "repeat",
                          class: "form-select",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newTaskRepeat) = $event))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enumToMap(_ctx.tasks), ([key, value]) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: key,
                              value: value.value
                            }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_28))
                          }), 128 /* KEYED_FRAGMENT */))
                        ], 512 /* NEED_PATCH */), [
                          [_vModelSelect, _ctx.newTaskRepeat]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _hoisted_30,
                        _hoisted_31,
                        (_ctx.patient && !_ctx.isPalliativeSolution)
                          ? _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_32, [
                              (
                                        (_ctx.patient.benefitPeriodStartDate || _ctx.patient.transferBenefitPeriodStartDate) &&
                                        _ctx.patient.benefitPeriodEndDate
                                    )
                                ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                                    _hoisted_34,
                                    (_ctx.patient.isTransfer)
                                      ? (_openBlock(), _createElementBlock("strong", _hoisted_35, _toDisplayString(_ctx.formatDate(_ctx.patient.transferBenefitPeriodStartDate)), 1 /* TEXT */))
                                      : (_openBlock(), _createElementBlock("strong", _hoisted_36, _toDisplayString(_ctx.formatDate(_ctx.patient.benefitPeriodStartDate)), 1 /* TEXT */)),
                                    _hoisted_37,
                                    _createElementVNode("strong", null, _toDisplayString(_ctx.formatDate(_ctx.patient.benefitPeriodEndDate)) + ")", 1 /* TEXT */)
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_38, [
                                    (_ctx.isPatientPending)
                                      ? (_openBlock(), _createElementBlock("strong", _hoisted_39, "(Current Benefit Period: Pending)"))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_40, " No Benefit Period Found "))
                                  ]))
                            ])), [
                              [_directive_tooltip, { title: `Current Benefit Period` }]
                            ])
                          : _createCommentVNode("v-if", true),
                        (_ctx.newTaskRepeat == 0)
                          ? (_openBlock(), _createBlock(_component_DatePicker, {
                              key: 1,
                              getDate: _ctx.changeNewTaskSingleDate
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_41, [
                                  _createElementVNode("input", {
                                    name: "newTaskSingleDate",
                                    type: "text",
                                    class: _normalizeClass(["form-control", `${!_ctx.v$.newTaskSingleDate?.$error ? '' : 'field-invalid mt-0'}`]),
                                    placeholder: "MM/DD/YYYY",
                                    value: _ctx.formatDateInput(_ctx.newTaskSingleDate),
                                    onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.v$.newTaskSingleDate?.$touch && _ctx.v$.newTaskSingleDate?.$touch(...args)))
                                  }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_42),
                                  _hoisted_43
                                ]),
                                (_ctx.v$.newTaskSingleDate?.$error)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_44, "Date is required."))
                                  : _createCommentVNode("v-if", true)
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["getDate"]))
                          : _createCommentVNode("v-if", true),
                        (_ctx.newTaskRepeat == 1 || _ctx.newTaskRepeat == 2 || _ctx.newTaskRepeat == 4)
                          ? (_openBlock(), _createBlock(_component_DateRangePicker, {
                              key: 2,
                              options: _ctx.newTaskRangePickerOptions
                            }, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: _normalizeClass(["form-control", `${!_ctx.v$.newTaskDateRange?.$error ? '' : 'field-invalid'}`]),
                                  placeholder: "MM/DD/YYYY",
                                  name: "daterange",
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newTaskDateRange) = $event)),
                                  onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.setNewTaskDateRange && _ctx.setNewTaskDateRange(...args))),
                                  onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.v$.newTaskDateRange?.$touch && _ctx.v$.newTaskDateRange?.$touch(...args)))
                                }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                                  [_vModelText, _ctx.newTaskDateRange]
                                ]),
                                (_ctx.v$.newTaskDateRange?.$error)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_45, "Date is required."))
                                  : _createCommentVNode("v-if", true)
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["options"]))
                          : _createCommentVNode("v-if", true),
                        (_ctx.newTaskRepeat == 3)
                          ? (_openBlock(), _createBlock(_component_MultiDatePicker, {
                              key: 3,
                              result: _ctx.newTaskFlexDates,
                              onUpdateResult: _ctx.updatenewTaskFlexDates
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("input", {
                                  class: _normalizeClass(["form-control", `${!_ctx.v$.newTaskFlexDates?.$error ? '' : 'field-invalid mt-0'}`]),
                                  placeholder: "MM/DD/YYYY",
                                  onBlur: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.v$.newTaskFlexDates?.$touch && _ctx.v$.newTaskFlexDates?.$touch(...args)))
                                }, null, 34 /* CLASS, HYDRATE_EVENTS */)
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["result", "onUpdateResult"]))
                          : _createCommentVNode("v-if", true),
                        (_ctx.v$.newTaskFlexDates?.$error)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_46, "Date is required."))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _hoisted_48,
                        _hoisted_49,
                        _createVNode(_component_TypeaheadInput, {
                          getData: _ctx.availableTasksFilter,
                          value: _ctx.taskList,
                          onValueChanged: _ctx.changeTaskList,
                          placeholder: "Type to Filter Task",
                          disabled: !_ctx.isDateSelected,
                          "show-all-by-default": true,
                          "open-on-focus": true,
                          "must-select-value": true,
                          ref: "typeAheadRefTask",
                          onBlurredInput: _ctx.v$.taskList?.$touch,
                          class: _normalizeClass(`${!_ctx.v$.taskList?.$error ? '' : 'field-invalid'}`)
                        }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "disabled", "onBlurredInput", "class"]),
                        (_ctx.v$.taskList?.$error)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_50, "Task is required."))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createElementVNode("div", _hoisted_51, [
                        _hoisted_52,
                        _createVNode(_component_TypeaheadInput, {
                          getData: _ctx.employeeListFilter,
                          value: _ctx.scheduleEmployeeId,
                          onValueChanged: _ctx.changeScheduleEmployeeId,
                          placeholder: "Type to Search Employee",
                          "show-all-by-default": true,
                          disabled: !_ctx.isDateSelected || !_ctx.isTaskSelected || _ctx.employeeIsPreSelected,
                          ref: "typeAheadRefEmp"
                        }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "disabled"])
                      ]),
                      _createElementVNode("div", _hoisted_53, [
                        _hoisted_54,
                        _hoisted_55,
                        _withDirectives(_createElementVNode("select", {
                          class: _normalizeClass(["form-select", `${!_ctx.v$.newTask.patientPayerId?.$error ? '' : 'field-invalid'}`]),
                          name: "payer",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newTask.patientPayerId) = $event)),
                          onBlur: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.v$.newTask.patientPayerId?.$touch && _ctx.v$.newTask.patientPayerId?.$touch(...args)))
                        }, [
                          _hoisted_56,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payerTypes, (payer) => {
                            return (_openBlock(), _createElementBlock("optgroup", {
                              key: payer.name,
                              label: payer.name
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.patientPayers.filter((p) => p.payerType === payer.value), (type) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: type.id,
                                  key: type.id
                                }, _toDisplayString(type.name), 9 /* TEXT, PROPS */, _hoisted_58))
                              }), 128 /* KEYED_FRAGMENT */))
                            ], 8 /* PROPS */, _hoisted_57))
                          }), 128 /* KEYED_FRAGMENT */))
                        ], 34 /* CLASS, HYDRATE_EVENTS */), [
                          [_vModelSelect, _ctx.newTask.patientPayerId]
                        ]),
                        (_ctx.v$.newTask.patientPayerId?.$error)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_59, "Payer is required."))
                          : _createCommentVNode("v-if", true)
                      ]),
                      (!_ctx.isPalliativeSolution)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                            _hoisted_61,
                            _withDirectives(_createElementVNode("select", {
                              class: "form-select",
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.shiftLength) = $event))
                            }, [
                              _hoisted_62,
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (i) => {
                                return _createElementVNode("option", {
                                  key: i,
                                  value: i
                                }, _toDisplayString(i) + " " + _toDisplayString(i === 1 ? "Hour" : "Hours"), 9 /* TEXT, PROPS */, _hoisted_63)
                              }), 64 /* STABLE_FRAGMENT */))
                            ], 512 /* NEED_PATCH */), [
                              [_vModelSelect, _ctx.shiftLength]
                            ])
                          ]))
                        : _createCommentVNode("v-if", true),
                      (!_ctx.isPalliativeSolution)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                            _hoisted_65,
                            _createVNode(_component_TimePicker, { onUpdateProps: _ctx.changeStartTime }, {
                              default: _withCtx(() => [
                                _createElementVNode("input", {
                                  type: "text",
                                  class: "form-control",
                                  value: _ctx.shiftStartTime,
                                  autocomplete: "off",
                                  maxlength: "8",
                                  disabled: _ctx.shiftLength <= 0,
                                  placeholder: "Enter Shift Start Time"
                                }, null, 8 /* PROPS */, _hoisted_66)
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onUpdateProps"])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_67, [
                            _hoisted_68,
                            _createVNode(_component_TimePicker, { onUpdateProps: _ctx.changeStartTime }, {
                              default: _withCtx(() => [
                                _createElementVNode("input", {
                                  type: "text",
                                  class: "form-control",
                                  value: _ctx.shiftStartTimePal,
                                  autocomplete: "off",
                                  maxlength: "8",
                                  placeholder: "Enter Scheduled Start Time"
                                }, null, 8 /* PROPS */, _hoisted_69)
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onUpdateProps"])
                          ])),
                      (_ctx.isPalliativeSolution)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                            _hoisted_71,
                            (_ctx.shiftStartTimePal)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_72, "*"))
                              : _createCommentVNode("v-if", true),
                            _createVNode(_component_TimePicker, { onUpdateProps: _ctx.changeEndTime }, {
                              default: _withCtx(() => [
                                _createElementVNode("input", {
                                  type: "text",
                                  class: _normalizeClass(["form-control", `${!_ctx.v$.shiftEndTime?.$error ? '' : 'field-invalid'}`]),
                                  value: _ctx.shiftEndTime,
                                  autocomplete: "off",
                                  maxlength: "8",
                                  disabled: !_ctx.shiftStartTimePal,
                                  placeholder: "Enter Scheduled End Time",
                                  onBlur: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.v$.shiftEndTime?.$touch && _ctx.v$.shiftEndTime?.$touch(...args)))
                                }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_73)
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onUpdateProps"]),
                            (_ctx.v$.shiftEndTime?.$error)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_74, "Shift End Time is required."))
                              : _createCommentVNode("v-if", true)
                          ]))
                        : _createCommentVNode("v-if", true),
                      (!_ctx.isPalliativeSolution)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              id: "on-call-visit",
                              class: "form-check-input",
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.newTask.onCall) = $event))
                            }, null, 512 /* NEED_PATCH */), [
                              [_vModelCheckbox, _ctx.newTask.onCall]
                            ]),
                            _hoisted_76
                          ]))
                        : _createCommentVNode("v-if", true),
                      (_ctx.isPalliativeSolution)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                            _createElementVNode("div", _hoisted_78, [
                              _withDirectives(_createElementVNode("input", {
                                type: "radio",
                                id: "on-call",
                                name: "on-call-prn",
                                class: "form-check-input",
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.visitType) = $event)),
                                value: _ctx.visitTypeEnum.OnCall,
                                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.visitTypeRadioClick(_ctx.visitTypeEnum.OnCall)))
                              }, null, 8 /* PROPS */, _hoisted_79), [
                                [_vModelRadio, _ctx.visitType]
                              ]),
                              _hoisted_80
                            ]),
                            _createElementVNode("div", _hoisted_81, [
                              _withDirectives(_createElementVNode("input", {
                                type: "radio",
                                id: "prn",
                                name: "on-call-prn",
                                class: "form-check-input",
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.visitType) = $event)),
                                value: _ctx.visitTypeEnum.Prn,
                                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.visitTypeRadioClick(_ctx.visitTypeEnum.Prn)))
                              }, null, 8 /* PROPS */, _hoisted_82), [
                                [_vModelRadio, _ctx.visitType]
                              ]),
                              _hoisted_83
                            ])
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]),
                    (_ctx.newTaskRepeat > 0 && _ctx.newTask.startDates.length > 0 && _ctx.isPalliativeSolution)
                      ? (_openBlock(), _createElementBlock("section", _hoisted_84, [
                          _createElementVNode("section", _hoisted_85, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.taskList?.name), 1 /* TEXT */),
                            _hoisted_86,
                            _createElementVNode("b", null, _toDisplayString(_ctx.employeeName), 1 /* TEXT */),
                            _hoisted_87,
                            _hoisted_88,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newTask.startDates, (item, index) => {
                              return (_openBlock(), _createElementBlock("span", { key: item }, [
                                _createElementVNode("b", null, _toDisplayString(_ctx.formatDate(item, "MMM DD, YYYY")), 1 /* TEXT */),
                                (index !== _ctx.newTask.startDates.length - 1)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_89, ","))
                                  : _createCommentVNode("v-if", true)
                              ]))
                            }), 128 /* KEYED_FRAGMENT */)),
                            _hoisted_90,
                            (_ctx.shiftLength && _ctx.shiftStartTime)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_91, [
                                  _hoisted_92,
                                  _createElementVNode("b", null, _toDisplayString(_ctx.shiftStartTime), 1 /* TEXT */),
                                  _hoisted_93,
                                  _createElementVNode("b", null, _toDisplayString(_ctx.shiftEndTime), 1 /* TEXT */)
                                ]))
                              : _createCommentVNode("v-if", true)
                          ])
                        ]))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("section", _hoisted_94, [
                      (_ctx.taskListItems && _ctx.taskListItems.id && !_ctx.isPalliativeSolution)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                            _createVNode(_component_FrequencyCheck, {
                              "visit-details": _ctx.visitDetails,
                              "visit-dates": _ctx.newTaskStartDates,
                              onUpdateVisitDates: _ctx.updateVisitDates,
                              "selected-task": _ctx.taskListItems,
                              "is-outside-frequency": _ctx.isOutsideFrequency,
                              onUpdateOutsideFrequency: _ctx.updateOutsideFrequency
                            }, null, 8 /* PROPS */, ["visit-details", "visit-dates", "onUpdateVisitDates", "selected-task", "is-outside-frequency", "onUpdateOutsideFrequency"])
                          ]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ])),
              (!_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                    (!_ctx.isOutsideFrequency)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-primary btn-md",
                            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.createTask('1')))
                          }, "Save Task"),
                          _createVNode(_component_SaveNotifyUser, {
                            "agency-id": _ctx.visitDetails.AgencyId,
                            "button-name": "Save and Notify Employee",
                            onHandleSaveVisit: _cache[17] || (_cache[17] = ($event: any) => (_ctx.createTask('3'))),
                            "info-classes": "pt-2 mt-2"
                          }, null, 8 /* PROPS */, ["agency-id"]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-primary btn-md ms-2",
                            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.saveAndAddAnother('2')))
                          }, " Save Task and Add Another ")
                        ], 64 /* STABLE_FRAGMENT */))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-primary btn-md",
                            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showFrequencyWarning('1')))
                          }, " Save Task "),
                          _createVNode(_component_SaveNotifyUser, {
                            "agency-id": _ctx.visitDetails.AgencyId,
                            "button-name": "Save and Notify Employee",
                            onHandleSaveVisit: _cache[20] || (_cache[20] = ($event: any) => (_ctx.showFrequencyWarning('3'))),
                            "info-classes": "pt-2 mt-2"
                          }, null, 8 /* PROPS */, ["agency-id"]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-primary btn-md ms-2",
                            onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.showFrequencyWarning('2')))
                          }, " Save Task and Add Another ")
                        ], 64 /* STABLE_FRAGMENT */)),
                    _createElementVNode("span", null, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "ms-2 mb-2 mb-md-0 btn btn-md btn-outline-secondary",
                        onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.cancel()))
                      }, " Cancel ")
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["application-id"])
        ]))
      : _withDirectives((_openBlock(), _createElementBlock("section", _hoisted_97, [
          _hoisted_98,
          _hoisted_99,
          _createElementVNode("div", _hoisted_100, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-xs btn-primary",
              onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.createTask(_ctx.saveType)))
            }, "Schedule Task"),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-xs btn-outline-secondary ms-2",
              onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.closeFrequencyWarning()))
            }, " Cancel ")
          ])
        ], 512 /* NEED_PATCH */)), [
          [_vShow, !_ctx.isPalliativeSolution && !_ctx.isScheduling]
        ]),
    (_ctx.isScheduling)
      ? (_openBlock(), _createElementBlock("section", _hoisted_101, _hoisted_103))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}